import React, { useState, useEffect } from 'react'
import {
  Container,
  TextCaption,
  Icon,
  Link,
  TextBody
} from '@pmi/pmi-iqos-ds-react'
import { cookie, getRoute, Routes } from '@pmi/pmi-iqos-shared-react'
import { CheckoutCartItem } from '@dcx-common/components'

const SummaryDropdown = ({ cart, isUpgrade, translations }) => {
  const [cartItems, setCartItems] = useState([])

  const formatCartItems = () => {
    const cartItems = []
    cart.products.map(el => {
      let item = el.chainId && cartItems.find(p => p.chainId === el.chainId)
      if (item) {
        if (!el.isLogistics) {
          item.products.push(el)
        }
      } else if (!el.isSample || el.isSampleConfirmed) {
        if (!el.isLogistics) {
          item = {
            chainId: el.chainId,
            chainName: el.chainName,
            chainPrice: el.chainPrice,
            chainPriceDiscountValue: el.chainPriceDiscount,
            chainPriceDisplayDiscount: el.displayDiscount,
            products: [el]
          }
          cartItems.push(item)
        }
      }
    })
    setCartItems(cartItems)
  }

  useEffect(() => {
    formatCartItems()
  }, [cart])

  const renderItems = () => {
    return cartItems.map((item, index) => {
      const position =
        index === cartItems.length - 1 ? 'last' : index === 0 ? 'first' : null
      return (
        <Container key={index}>
          <CheckoutCartItem
            position={position}
            item={item}
            translations={translations}
          />
        </Container>
      )
    })
  }

  return (
    <Container fullWidth overflow bg={Container.backgrounds.white}>
      <Container divider={Container.dividers.bottom}>
        <Container
          display={Container.displays.flex}
          justifyContent={Container.justifyContentValues.between}
          alignItems={Container.alignItemsValues.center}
          py={['5', '5', '6']}
          px="6"
          divider={Container.dividers.bottom}>
          <TextCaption size={TextCaption.sizes.m}>
            {translations.tk_stepOneOrderItems}
          </TextCaption>

          <Link
            href={getRoute(isUpgrade ? Routes.upgradeOfferCart : Routes.cart)}
            onClickHandler={() => {
              isUpgrade && cookie.setUpgradeFlowFlag(true)
            }}
            newTab={false}
            underlined={false}
            data-testing="Checkout_Link_GoToCart">
            <Container
              display={Container.displays.flex}
              alignItems={Container.alignItemsValues.center}>
              <Container pr="2">
                <Icon size={Icon.sizes.xs} image={Icon.images.address} />
              </Container>
              <TextBody size={TextBody.sizes.s}>
                {translations.tk_stepOneViewCart}
              </TextBody>
            </Container>
          </Link>

          {/* <Link
            href={getRoute(isUpgrade ? Routes.upgradeOfferCart : Routes.cart)}
            newTab={false}
            underlined={false}
            data-testing="Checkout_Link_GoToCart">
            <Container
              display={Container.displays.flex}
              alignItems={Container.alignItemsValues.center}>
              <Container pr="2">
                <Icon size={Icon.sizes.xs} image={Icon.images.address} />
              </Container>
              <TextCaption size={TextCaption.sizes.m}>
                {translations.tk_stepOneViewCart}
              </TextCaption>
            </Container>
          </Link> */}
        </Container>
      </Container>

      <Container>{renderItems()}</Container>
    </Container>
  )
}

export default SummaryDropdown
